import { FacadeService } from '@lib/services/facade'
import { CountryCode, isValidCountryCode, getCountryName } from '@lib/utils/countries'

// US, Canada, Ireland, Australia, United Kingdom, New Zealand
export const englishSpeakingCountryCodes: Set<CountryCode> = new Set<CountryCode>(['US', 'CA', 'IE', 'AU', 'GB', 'NZ'])

export class GeoLocationService {
  readonly countryCode: CountryCode | undefined
  readonly countryName: string | undefined
  readonly subdivisionName: string | undefined
  readonly cityName: string | undefined
  readonly postalCode: string | undefined

  constructor(facade: FacadeService) {
    const facadeData = facade.get()
    const facadeDataGeoLocation = facadeData?.geoLocation
    const facadeDataCountryCode = facadeDataGeoLocation?.countryCode
    if (isValidCountryCode(facadeDataCountryCode)) {
      this.countryCode = facadeDataCountryCode as CountryCode
      this.countryName = getCountryName(this.countryCode)
    }
    this.subdivisionName = facadeDataGeoLocation?.subdivisionName
    this.cityName = facadeDataGeoLocation?.cityName
    this.postalCode = facadeDataGeoLocation?.postalCode
  }
}
